//#access_token=NwAExz...BV3O2Tk&token_type=Bearer&expires_in=3600&state=123
let accessToken;
const clientID = '851ed76188164615a87529724f085b9f';
const redirectURI = 'https://ajruddy.com/jammming/';

const Spotify = {
	getAccessToken(){
		//check if set
		if(accessToken){
			return accessToken;
		} else {
			const access_token = window.location.href.match(/access_token=([^&]*)/);
			const expires_in = window.location.href.match(/expires_in=([^&]*)/);
			if(access_token && expires_in){
				accessToken = access_token[1];
				const expiresIn = Number(expires_in[1]);
				window.setTimeout(() => accessToken = '', expiresIn * 1000);
				window.history.pushState('Access Token', null, '/');
			}else{
				const accessUrl = `https://accounts.spotify.com/authorize?client_id=${clientID}&response_type=token&scope=playlist-modify-public&redirect_uri=${redirectURI}`;
				window.location = accessUrl;
			}
		}
	},

	search(term){
		const accessToken = Spotify.getAccessToken();
		return fetch(`https://api.spotify.com/v1/search?type=track&q=${term}`, { headers: { Authorization: `Bearer ${accessToken}` }
	    }).then(response =>{
	    	return response.json();
		}).then(jsonResponse => {
			if(!jsonResponse.tracks){
				return [];
			}
		  	return jsonResponse.tracks.items.map(track => ({
				name: track.name,
  				artist: track.artists[0].name,
  				album: track.album.name,
  				id: track.id,
  				uri: track.uri
		  	}));
		});
	},

	savePlaylist(playlistName,trackURIs){
		if(!playlistName || !trackURIs){
			return;
		}
			//access token
		const accessToken = Spotify.getAccessToken();
		const headers = { Authorization: `Bearer ${accessToken}` };
			//userid empty variable
		let userID;

		return fetch('https://api.spotify.com/v1/me', {headers: headers}
	    ).then(response => response.json()
	    ).then(jsonResponse => {
	      userID = jsonResponse.id;
	      return fetch(`https://api.spotify.com/v1/users/${userID}/playlists`, {
	        headers: headers,
	        method: 'POST',
	        body: JSON.stringify({name: playlistName})
	      }).then(response => response.json()
	      ).then(jsonResponse => {
	        const playlistId = jsonResponse.id;
	        return fetch(`https://api.spotify.com/v1/users/${userID}/playlists/${playlistId}/tracks`, {
	          headers: headers,
	          method: 'POST',
	          body: JSON.stringify({uris: trackURIs})
	        });
	      });
	    });
	}
}

export default Spotify;